<div class="switch-wrapper">
    <div class="slider" [class.slider-right]="selectedValue() === secondOption().value"></div>

    <button
        type="button"
        class="option-button"
        [class.active]="selectedValue() === firstOption().value"
        (click)="selectOption(firstOption().value)"
    >
        <span>{{ firstOption().label | translate }}</span>
    </button>

    <button
        type="button"
        class="option-button"
        [class.active]="selectedValue() === secondOption().value"
        (click)="selectOption(secondOption().value)"
    >
        <span>{{ secondOption().label | translate }}</span>
    </button>
</div>
